import WebServiceRequest from "../WebServiceRequest";

class FaqCategoryGetAllRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FaqCategory/GetList");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class FaqGetSingleRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FaqCategory/Get");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}

class FaqUpdateSingleRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FaqCategory/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class FaqCategoryCreateRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FaqCategory/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class FaqCategoryDeleteRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FaqCategory/Delete");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}

export {
  FaqCategoryGetAllRequest,
  FaqCategoryCreateRequest,
  FaqGetSingleRequest,
  FaqUpdateSingleRequest,
  FaqCategoryDeleteRequest,
};
